import { useRouter } from "next/router";
import { objectUtils } from "@talladega/helpers";
import useCreateCustomerInformation from "./useCreateCustomerInformation";
import { CustomerQueryParams } from "../types";

export const useRawCustomerInfoFromQuery = () => {
  const router = useRouter();

  const { first, last, address, city, province, postal, phoneNumber, email } =
    router.query as CustomerQueryParams;

  return objectUtils.mapValidProperties({
    first,
    last,
    address,
    city,
    province,
    postal,
    phoneNumber,
    email,
  }) as CustomerQueryParams;
};

const useCustomerInfoFromQuery = () => {
  const {
    first: firstName,
    last: lastName,
    address: streetAddress,
    city,
    province: provinceAbbr,
    postal: postalCode,
    phoneNumber,
    email,
  } = useRawCustomerInfoFromQuery();

  const customerInformation = useCreateCustomerInformation({
    firstName,
    lastName,
    streetAddress,
    city,
    provinceAbbr,
    postalCode,
    phoneNumber,
    email,
  });

  return customerInformation;
};

export default useCustomerInfoFromQuery;
